import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { useMultiStyleConfig as p, Alert as R, Box as b, AlertTitle as x, AlertDescription as $ } from "@chakra-ui/react";
import y from "./AlertIcon.mjs";
import { CloseButton as C } from "../../dataDisplay/CloseButton/CloseButton.mjs";
import { getPaddingRightValue as S } from "./alertFunctions.mjs";
const s = ({
  alertStyleProps: t,
  children: g,
  descriptionStyleProps: u,
  iconStyleProps: f,
  id: l,
  onClose: m,
  showCloseButton: i = !0,
  status: n = "info",
  title: c,
  titleStyleProps: a,
  "data-testid": o,
  variant: r = "left-accent",
  ...A
}) => {
  const h = p("Alert", { variant: r });
  return /* @__PURE__ */ d(
    R,
    {
      id: l,
      status: n,
      "data-testid": o,
      variant: r,
      addRole: r !== "toast",
      paddingRight: S(r, i),
      ...t,
      ...A,
      children: [
        /* @__PURE__ */ e(y, { status: n, ...f }),
        /* @__PURE__ */ d(
          b,
          {
            width: "100%",
            lineHeight: 0,
            ...(r === "global" || r === "left-accent") && i && {
              borderRightWidth: "1px",
              borderRightColor: "gray.200",
              borderRightStyle: "solid",
              paddingRight: { base: 2, md: 3 }
            },
            children: [
              c && /* @__PURE__ */ e(
                x,
                {
                  id: l && `${l}-title`,
                  "data-testid": o && `${o}-title`,
                  ...a,
                  children: c
                }
              ),
              /* @__PURE__ */ e(
                $,
                {
                  id: l && `${l}-desc`,
                  "data-testid": o && `${o}-desc`,
                  ...u,
                  children: g
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ e(C, { "aria-label": "Close", sx: h.close, size: "sm", onClick: m })
      ]
    }
  );
}, E = (t) => /* @__PURE__ */ e(s, { status: "info", ...t }), H = (t) => /* @__PURE__ */ e(s, { status: "warning", ...t }), M = (t) => /* @__PURE__ */ e(s, { status: "success", ...t }), P = (t) => /* @__PURE__ */ e(s, { status: "error", ...t });
export {
  s as Alert,
  P as ErrorAlert,
  E as InfoAlert,
  M as SuccessAlert,
  H as WarningAlert
};
